import { ADMIN_PANEL_ROLE_EDIT_PATH, EditRole } from "./pages/edit-role";
import { ADMIN_PANEL_ROLES_PATH, Roles } from "./pages/roles";
import { RestrictRoles } from "./shared/access/restrict-roles";

export const rolesRoutes = [
  {
    path: ADMIN_PANEL_ROLES_PATH,
    element: (
      <RestrictRoles>
        <Roles />
      </RestrictRoles>
    ),
  },
  {
    path: ADMIN_PANEL_ROLE_EDIT_PATH,
    element: (
      <RestrictRoles>
        <EditRole />
      </RestrictRoles>
    ),
  },
];
